module.exports = __webpack_public_path__ + "img/img5.3a847a79.png";